import { render } from "./client-page.vue?vue&type=template&id=1897db02"
import script from "./client-page.vue?vue&type=script&lang=js"
export * from "./client-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__